import {Component, computed, input} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {Panel} from 'primeng/panel';
import {TableModule} from 'primeng/table';
import {TranslocoPipe} from '@jsverse/transloco';
import {AppCurrencyPipe} from '@frontend/shared';
import {PanelHeaderComponent} from '../../../../../../../../shared/components/header/panel-header/panel-header.component';
import {TotalFeeData, TotalFeesContainer} from './total-fees.types';
import {NgClass} from '@angular/common';
import {model, effect} from '@angular/core';
import {SumFees} from '../step-8-2-3-rfq-preview-price-list.types';

interface FeeRowVM {
  data: TotalFeeData;
  yearlyFees: number[];
  totalAcrossScope: number;
}

@Component({
  selector: 'app-total-fees-module',
  imports: [
    ReactiveFormsModule,
    Panel,
    PanelHeaderComponent,
    TableModule,
    TranslocoPipe,
    AppCurrencyPipe,
    NgClass,
  ],
  templateUrl: './total-fees.component.html',
  providers: [TranslateDirectusPipe],
})
export class TotalFeesModuleComponent {
  readonly inputObject = input.required<TotalFeesContainer>();

  readonly feeRows = computed<FeeRowVM[]>(() => {
    const current = this.inputObject();
    if (!current?.data) return [];

    return current.data.map((item) => {
      const yearlyFees = item.sumFees.columnTotalsPerYear ?? [];

      return {
        data: item,
        yearlyFees: yearlyFees,
        totalAcrossScope: item.sumFees.grandTotalAllYears,
      } as FeeRowVM;
    });
  });

  readonly columnTotalsPerYear = computed<number[]>(() => {
    const rows = this.feeRows();
    if (!rows.length) return [];

    const yearCount = rows[0].data.sumFees.columnTotalsPerYear?.length ?? 0;
    if (yearCount === 0) return [];

    return Array.from({length: yearCount}, (_, yearIndex) =>
      rows.reduce((sum, row) => sum + (row.data.sumFees.columnTotalsPerYear[yearIndex] ?? 0), 0),
    );
  });

  readonly grandTotalAllYears = computed<number>(() =>
    this.feeRows().reduce((sum, row) => sum + row.totalAcrossScope, 0),
  );

  readonly sumFees = computed<SumFees>(() => {
    const columnTotalsPerYear = this.columnTotalsPerYear();
    const grandTotalAllYears = this.grandTotalAllYears();
    return {
      columnTotalsPerYear: columnTotalsPerYear,
      grandTotalAllYears: grandTotalAllYears,
    } as SumFees;
  });

  readonly sumFeesModel = model<SumFees>({} as SumFees);

  constructor() {
    effect(() => {
      this.sumFeesModel.set(this.sumFees());
    });
  }
}
